/**
 * Copy for the insurance panel on a work's record — OND-48.
 *
 * The panel is a reading of the work's history and holds no form, so there is
 * no error copy here: nothing on it writes. Recording a period is the Insurance
 * chip in "+ Add history", which is the only door, and that is deliberate — the
 * whole of OND-48's answer is that this display is DERIVED and not a second,
 * editable insurer field that could disagree with the record.
 */

export const INSURANCE_COPY = {
  title: "Insurance",

  /**
   * Said once above the list, because the list itself cannot say it.
   *
   * Two policies covering the same months is a normal state of a real record —
   * a renewal taken out early, a specific-risk policy alongside a general one —
   * and a reader who did not know that would read an overlap as a mistake in
   * the record rather than a fact about the cover.
   */
  overlapNote: "Periods may overlap. A renewal is recorded beside the period it renews, not instead of it.",

  /**
   * The dispute banner, and the reason the panel has one at all.
   *
   * OND-95: "Do not let another confirmation hide a live dispute, or present a
   * disputed entry as unqualified confirmed cover." A row's own strip already
   * says DISPUTED, but a reader scanning the aside for "is this insured" needs
   * to meet the disagreement before they take the figure as settled — so it is
   * said at the top of the panel as well as on the row.
   */
  disputedNouns: ["period of cover is disputed", "periods of cover are disputed"] as const,
  disputedDetail: "Open it in the artwork history to read the reason and who recorded it.",

  /** The link on each row through to the entry the row was derived from. */
  openEntry: "See in artwork history",

  /** When the record names an insurer and no sum. */
  amountUnknown: "Amount not recorded",
  /** When the record names an insurer and no policy number. */
  policyUnknown: "No policy reference recorded",
} as const;
